import { render, staticRenderFns } from "./WorkCalendar.vue?vue&type=template&id=47855c40"
import script from "./WorkCalendar.vue?vue&type=script&lang=js"
export * from "./WorkCalendar.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendar.vue?vue&type=style&index=0&id=47855c40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports